import angular from 'angular';
import uiRouter from 'angular-ui-router';
import routing from './feedback.routes';
import addHtml from './modal/add.html';
import _ from 'lodash';


export class FeedbackController {
    $http;
    socket;
    awesomeThings = [];
    feedbacks = [];
    newThing = '';
    currentPage = 1;

    /*@ngInject*/
    constructor($http, $scope, socket, $uibModal, $cookies, $cookieStore, $location) {
        this.$http = $http;
        this.socket = socket;
        this.$uibModal = $uibModal;
        this.$cookies = $cookies;
        this.$cookieStore = $cookieStore;
        this.$location = $location;


        $scope.$on('$destroy', function () {
            socket.unsyncUpdates('feedback');
        });
    }

    $onInit() {

        this.$http.get('/api/feedbacks/', {
            params: {
                'page': this.currentPage - 1,
                'size': 20
            }
        })
            .then(response => {
                if (response.data.data) {
                    _.map(response.data.data, function (item, index) {
                        let time = new Date(item.createdAt).getTime();
                        if (time <= 1570438358000 || item.select_problem) {
                            item.type = '用户反馈';
                        }
                    });

                    this.maxSize = 20;
                    this.totalCount = response.data.count;
                    this.totalItems = response.data.count / 2;

                    this.feedbacks = response.data.data;

                    this.socket.syncUpdates('feedback', this.feedbacks);
                }
            });
    }

    // addThing() {
    //   if(this.newThing) {
    //     this.$http.post('/api/things', {
    //       name: this.newThing
    //     });
    //     this.newThing = '';
    //   }
    // }

    deleteFeedback(feedback, index) {
        this.$http.delete(`/api/feedbacks/${feedback.feed_back_id}`).then(response => {
            if (response.status === 204) {
                this.feedbacks.splice(index, 1)
            }
        }, error => {
            console.log(error);
        });
    }


    // addSurvey() {
    //   const surveys = this.surveys;
    //   this.$uibModal.open({
    //     template: addHtml,
    //     size: 'lg',
    //     /*@ngInject*/
    //     controller: function($scope, $http, $uibModalInstance) {
    //       $scope.vm = {};
    //       $scope.save = function(myForm) {
    //         if (myForm.$valid === false) {
    //           return false;
    //         } else {
    //           $http.post('/api/surveys', $scope.vm).then((response) => {
    //             $uibModalInstance.close(response.data);
    //           }, (error) => {
    //             console.log(error);
    //           });
    //         }
    //       };
    //       $scope.cancel = function() {
    //         $uibModalInstance.close();
    //       };
    //     }
    //   })
    //     .result.then(function(ret) {
    //     if (ret) {
    //       surveys.push(ret);
    //     }
    //   }, function () {
    //   });
    // }

}

export default angular.module('tttApp.feedback', [uiRouter])
    .config(routing)
    .component('feedback', {
        template: require('./feedback.html'),
        controller: FeedbackController
    })
    .name;



// WEBPACK FOOTER //
// ./client/app/feedback/feedback.component.js